document.addEventListener('DOMContentLoaded', function () {
  const footerExtra = document.querySelector('.footer__column--extra');
  const localization = document.querySelector('.footer__localization');
  const payment = document.querySelector('.footer__payment');

  if (!footerExtra || !localization || document.querySelector('.footer-widerruf-button')) {
    return;
  }

  const buttonWrapper = document.createElement('div');
  buttonWrapper.className = 'footer-widerruf-button';

  buttonWrapper.innerHTML = `
    <a href="/pages/eu-widerrufsformular">
      Bestellung widerrufen
    </a>
  `;

  if (payment) {
    footerExtra.insertBefore(buttonWrapper, payment);
  } else {
    localization.insertAdjacentElement('afterend', buttonWrapper);
  }
});